module.exports = __webpack_public_path__ + "img/basket3.e9a65c0c.svg";